import { Component, inject } from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MAT_DIALOG_DATA, MatDialogModule} from '@angular/material/dialog';
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogTitle,
  MatDialogContent,
} from '@angular/material/dialog';

@Component({
    selector: 'app-dlg-alert',
    imports: [
        MatDialogModule,
        MatButtonModule,
        MatDialogActions,
        MatDialogClose,
        MatDialogTitle,
        MatDialogContent
    ],
    templateUrl: './dlg-alert.component.html',
    styleUrl: './dlg-alert.component.scss'
})
export class DlgAlertComponent {

  title: string = 'Error';
  message: string = 'Houston, tenemos un problema';
  readonly data = inject<any>(MAT_DIALOG_DATA);

  constructor(){
    if (this.data){
      this.title = this.data.title || this.title;
      this.message = this.data.message || this.message;
    }
  }
}
